import React from 'react'
import inputComponents from './inputComponents'
import { checkTextTranslation, checkTranslation, getObject, setObject, translate } from '../../utils/useful'
import { nanoid } from 'nanoid'

class OutputsInput extends React.Component {
    state = {
        errors: {},
        data: [],
        width: window.innerWidth,
        header: [
            { type: 'TextInput', key: 'label', col: '2', information: { type: 'local', items: [], label: '{{lang}}Output label', placeholder: '{{lang}}Output label', required: true } },
            { type: 'FilterEditorInput', key: 'conditions', col: '2', information: { label: '{{lang}}Condition', hint: '{{lang}}If this condition be fulfilled, this output will be triggered', type: 'local', items: [], placeholder: '{{lang}}Add.Condition', required: true } },
        ],
        default: [
            { key: 'else', label: 'else', isElse: true, sort: 1000 },
            { key: 'output-1', label: 'Output', sort: 1 }
        ],
        show: true
    }

    componentDidMount() {
        // console.log('all props2', this.props.data)
        let data = this.props.data
        // if (!this.props.data) {
        //     // if (!Array.isArray(data)) {
        //     //     data = []

        //     //     // let input = [{ label: 'Input' }]

        //     //     // data.push({ label: 'Default', action: 'and' })
        //     //     data.push({ key: 'else', label: 'else', isElse: true })
        //     //     data.push({ key: 'output-1', label: 'Output 1', })
        //     // }

        //     // console.log("data", data)
        //     // this.props.changeValue(this.props.header.key, data)
        // }
        // if(this.props.data)
        this.init()
        window.addEventListener('resize', this.setFormWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setFormWidth)
    }

    componentDidUpdate(prevProps) {

        // console.log(this.props.data)

        if ((this.props.initData !== prevProps.initData) || (this.props.headers !== prevProps.headers) || ((this.props.data !== prevProps.data) && !prevProps.data)) {

            this.init()
        }
    }

    getForm = () => {
        // console.log(this.validator())
        if (this.validator()) {
            // return this.state.data ? this.state.data : {}
            return this.props.data

        } else {
            return null
        }
    }



    init = () => {
        // this.props.changeValue(this.props.header.key, data)
        // console.log(this.props.initData)
        // console.log(this.props.data)

        this.makeInitValue()
    }


    makeInitValue() {

        let data = this.props.data ?? this.state.default

        // console.log(this.props.header.key, data)
        setTimeout(() => {
            this.props.changeValue(this.props.header.key, data, this.props.extra)
        }, 200);
        // if (data == null) {
        //     data = {}
        // }
        // if (this.props.headers) {

        //     this.props.headers.forEach(header => {
        //         if (data[header.key] == null && header.information?.default != null) {
        //             data[header.key] = header.information?.default
        //         }
        //     });
        // }

        // setTimeout(() => {
        //     this.setState({ show: true }, () => {
        //         //     this.setFormWidth()
        //     })
        // }, 100);


    }


    validator() {
        let valid = true
        let errors = {}
        this.props.headers.forEach(header => {
            if (header.information?.required) {

                let value = getObject(this.props.data, header.key)

                if (header.type == 'ImageInput' || header.type == 'FileInput') {

                    if (!value || value === '') {
                        value = getObject(this.props.data, ('**files.' + header.key), 1)
                    }
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                } else {
                    // let value = getObject(this.state.data, header.key)
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }
                if (header.type == 'PhoneInput') {
                    // let value = getObject(this.state.data, header.key)
                    if (!value || value.length < 14) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }
            }
        })
        this.setState({ errors })
        return valid
    }



    setFormWidth = () => {
        if (this.form) {
            this.setState({ width: this.form.getBoundingClientRect().width })
        }
    }



    addNew = () => {
        let data = this.props.data
        if (!Array.isArray(data)) {
            data = []
        }

        // data.push({})

        let label = translate("Output " + (data.length))

        data.push({ key: "_" + nanoid(), label: label, sort: data.length })
        this.props.changeValue(this.props.header.key, data)
    }

    removeRow = (index) => {
        let data = this.props.data
        // if (!Array.isArray(data)) {
        //     data = []
        // }
        // data.push({})
        data.splice(index, 1)
        this.props.changeValue(this.props.header.key, data)
    }


    changeFiles = (files, key, extra) => {
        // let data = this.state.data ?? {}

        // if (data['**files'] == null) {
        //     data['**files'] = {}
        // }
        // value.formType = ''

        // this.props.header.information.headers.forEach(header => {
        //     if (header.key == key) {
        //         value.formType = header.type
        //         // value.single = header.information?.single
        //     }
        // });

        // data['**files'][key] = value
        // console.log(data)
        // this.setState({ data })
        // console.log(extra)
        // console.log(files)

        this.props.changeValue('**files', { [this.props.header.key + '.' + extra?.index + "~" + key]: files }, { append: 'object' })
        // this.props.changeValue('**files.' + this.props.header.key + '.' + extra?.index + "~" + key, files)

        // this.props.changeValue('**files', { [this.props.header.key+'!!' + '.' + key ]: files })

    }

    changeInit = (key, value, extra) => {

    }
    changeValue = (key, value, extra) => {
        let data = this.props.data
        let index = extra?.index

        // console.log('changevalue', data, extra)
        // console.log('changevalue', key, value)
        // return
        if (Array.isArray(data)) {
            data = setObject(data, key, value, false, index)
            // console.log('data updated', data)
            this.props.changeValue(this.props.header.key, data)
            // console.log('da' , this.props.data)
        }
    }



    formColBuilder(col) {
        let finalCol = 'col-12'

        // if (100 < this.state.width && col) {
        finalCol = 'col-' + col
        // }

        return finalCol
    }

    renderHeader(headers) {
        if (headers) {
            return (headers.map((header, index) => {
                console.log('hed', header)
                if (header.key != 'output') {
                    return (
                        <div key={index} className={" mb-1 form-label  p-0 text-capitalize text-semibold pt-2 " + this.formColBuilder(header.col)} >
                            <label className={'text-small mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{checkTextTranslation(header.information?.label)}</label>

                            {header.information?.hint && (
                                <div className="mx-1 text-start text-smallest">
                                    <div style={{ color: '#9ab', fontWeight: '500' }}>{checkTextTranslation(header.information?.hint)}</div>
                                </div>
                            )}
                        </div>
                    )
                }
            }))
        }
    }


    renderBody(headers, rawData, index) {
        // console.log('headers', headers)
        // console.log('this.props.data01010', this.props.data)
        return (
            // <div className="flexcc p-1">

            // {
            headers && headers.map((header, hindex) => {
                let Component = inputComponents[header.type]
                // console.log(rawData)
                // console.log(header.key)
                // console.log('============')
                let data = getObject(rawData, header.key)//data[header.key] ? data[header.key] : ''
                // console.log(data)
                // console.log('dataOj', data)
                let files
                if (rawData && rawData['**files']) {
                    files = getObject(rawData['**files'], header.key)//this.state.data[header.key] ? this.state.data[header.key] : ''
                }


                if (data == null && header.information?.default != null) {
                    data = header.information?.default
                }
                // console.log(this.props.optionsList)
                if (Component) {
                    return (
                        // <div key={hindex} className={" mb-0 p-0 " + this.formColBuilder(header.col)} >
                        <div key={hindex} className={"w-100 mb-0 p-0 pb-2"} >

                            <div className="w-100 m-0 prd-2">

                                <div className="w-100 p-0 mb-2">

                                    <p className={'text-smaller text-semibold mb-2 ' + (header.information?.required ? 'required' : '')}>
                                        {checkTranslation(header.information.label)}
                                    </p>

                                    <div className={"w-100 flexc " + (header.information.inputClass ?? (this.props.inputClass ? this.props.inputClass : ''))} >
                                        {header.information?.icon && (
                                            <img className="mrd-3" src={header.information?.icon} height="25px" alt="icon" />
                                        )}
                                        <Component changeInit={this.changeInit} extra={{ index }} header={header} data={data} files={files} changeFiles={this.changeFiles} changeValue={this.changeValue} variables={this.props.variables} optionsList={this.props.optionsList} />
                                    </div>
                                </div>

                                {header.information?.hint && (
                                    <div className={" mt-1 mld-2  text-start mt-2 "}>
                                        <p className='text-smaller  ' style={{ color: '#777', cursor: 'default' }} >{checkTextTranslation(header.information?.hint)}</p>
                                    </div>
                                )}

                                {this.props.errors && this.props.errors[header.key] && (
                                    <div className="col-12 mt-1 mld-2 text-start">
                                        <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors[header.key])}</small>
                                    </div>
                                )}

                                {this.state.errors && this.state.errors[header.key] && (
                                    <div className="col-12 mt-1 mld-2 text-start">
                                        <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.state.errors[header.key])}</small>
                                    </div>
                                )}



                            </div>
                        </div>
                    )
                }
            })
            //     }
            // </div>

        )
    }




    render() {
        // let headers = this.props.header.information?.headers
        let headers = this.state.header
        // console.log(this.props.data)
        if (this.state.show) {
            return (
                <section className="w-100  ewfwfe col-12 px-0" ref={(el) => this.form = el} style={{ borderTop: '0px solid #eee', borderBottom: '0px solid #eee' }}>
                    <div className={""} style={{}}>

                        {/* <div className="flexc w-100 mb-2" style={{ borderBottom: '1px solid #f0f0f0' }}>
                            {!this.props.header.information?.removeDisabled && (
                                <button className="flexcc p-1">
                                    <img src="/images/remove.png" width="18px" style={{ opacity: 0 }} />
                                </button>
                            )}
                            <div className="m-0 mb-1 w-100" style={{ flexWrap: 'nowrap' }}>
                                {this.renderHeader(headers)}
                            </div>
                        </div> */}

                        {Array.isArray(this.props.data) && this.props.data?.map((prop, index) => {
                            if (!prop.isElse) {

                                return (
                                    <div className="flexc w-100 position-relative" key={prop.key}>
                                        {(!this.props.header.information?.removeDisabled) && (
                                            <>
                                                {!prop['**notRemoveable'] && (
                                                    <button onClick={() => this.removeRow(index)} className="flexcc position-absolute flex-c" style={{ zIndex: 0, top: 6, right: 10 }} >
                                                        {/* <img src="/images/remove.png" width="14px" /> */}
                                                        <p className='text-smaller mld-1 text-semibold' style={{ color: '#aaa' }}>{translate("Remove output")}</p>
                                                    </button>
                                                )}


                                            </>
                                        )}
                                        <div key={index} className="m-0 mb-3 w-100 bordered-input pt-2 px-2" style={{ flexWrap: 'nowrap' }}>
                                            {this.renderBody(headers, prop, index)}
                                        </div>
                                    </div>

                                )
                            }
                        })}
                    </div>

                    {(!Array.isArray(this.props.data) || this.props.data.length == 0) && (
                        <div className='flexc mb-2  mt-0 '>
                            <div className='' style={{ borderRadius: 6, padding: '6px 0px', color: "#777" }}>
                                <p className="text-smaller text-semibold">{translate('No data is added')}</p>
                            </div>
                        </div>
                    )}


                    <div className={" mt-1 mld-2  text-start  mb-2 "}>
                        <p className='text-smaller  ' style={{ color: '#777', cursor: 'default' }} >{translate("If none of conditions be fulfilled, this else output will be triggered.")}</p>
                    </div>


                    {!this.props.header.information?.addDisabled && (
                        <div className="flexc ">
                            <button onClick={() => this.addNew()} className=" py-1" style={{ color: '#007aff', borderRadius: 4 }}>
                                <p className=" text-smaller  text-semibold">+ {translate("Add another output")}</p>
                            </button>
                        </div>
                    )}
                    {this.props.errors && (typeof this.props.errors == 'string') && (
                        <div className="col-12 text-start">
                            <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors)}</small>
                        </div>
                    )}

                </section>
            )
        } else {
            return (<div></div>)
        }
    }
}

export default OutputsInput;